<div class="py-4 px-0">
  <div class="container">
    <div class="row">
      <div class="col">
        <article>
          @switch (lang) {
            @default {
              <h1>Saavutettavuusseloste</h1>
              <p>Päivitetty 1.1.2024</p>
            }
            @case ('en') {
              <h1>Accessibility statement</h1>
              <p>Updated on 1 January 2024</p>
            }
            @case ('sv') {
              <h1>Tillgänglighetsutlåtande</h1>
              <p>Uppdaterat 1.1.2024</p>
            }
          }
          <ng-container>
            @for (item of accessibilityPolicy; track item) {
              <div>
                <h2>{{ item.heading }}</h2>
                @for (paragraph of item.content; track paragraph) {
                  <p [innerHTML]="paragraph"></p>
                }
              </div>
            }
          </ng-container>
        </article>
      </div>
    </div>
  </div>
</div>
